import React from "react";
import Question from "../subviews/Question";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/nav.scss";
import parse from "../parse";

const w = window;

class QuestionSection extends React.Component {
  buildPostContentViews(post) {
    let postCon = [];
    var className = "card card-body ";
    if (typeof post === "string") {
      postCon.push(<p>{parse(post)}</p>);
    } else {
      className = className + post.align + " " + post.style;
      post.text.map((c) => {
        if (c.includes("Total Score:")) {
          postCon.push(<b>{"Total Score: " + w["value"]}</b>);
        } else if (c.includes("Symptoms:")) {
          postCon.push(<b>{"Symptoms: " + w["value"]}</b>);
        } else {
          postCon.push(<p>{parse(c)}</p>);
        }
      });
    }
    return <div className={className}>{postCon}</div>;
  }
  render() {
    return (
      <div className="question-section">
        <h3 id="management_title">{this.props.title}</h3>
        <div id="management_results">
          {this.props.visibleQuestions.map((question) => (
            <Question
              question={question}
              currentSelection={w[question.id]}
              answerSelected={this.props.answerSelected}
              value={question.value}
              tab={this.props.tab}
            />
          ))}
        </div>
        {this.props.postContent.map((post) => this.buildPostContentViews(post))}
      </div>
    );
  }
}

export default QuestionSection;
